
import { createContext, useContext } from "react";
import io from "socket.io-client";
import Cookies from 'js-cookie';

// console.log('ENV FILE', process.env)
const SOCKET_URL = window.location.origin.includes("localhost")
	? process.env.REACT_APP_SOCKET_HOST
	: process.env.REACT_APP_SOCKET_HOST;


const socket = io.connect(SOCKET_URL,  {
	transports: ['websocket'], 
	auth: { token: Cookies.get('_auth') } // Pass the JWT token as an auth parameter
  });

// const socket = io.connect(SOCKET_URL);

const SocketContext = createContext();

const useSocketContext = () => useContext(SocketContext);

const SocketProvider = ({ children }) => {
	return (
		<SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
	);
};

export { useSocketContext, SocketProvider };